import { Optional } from './utils'

export type Controls = {
  main: string,
  alt: Array<string>,
  description: string,
}

export const ALL_CONTROLS: {[desc: string]: Controls} = {};

const key_map: {[key: string]: string} = {
  'esc': 'Escape',
  'tab': 'Tab',
  'enter': 'Enter',
  'space': ' ',
}

function get_key_from_display_key(k: string): string {
  return key_map[k] || k;
}

function check_key(control: Controls, key: string): boolean {
  if (key === get_key_from_display_key(control.main)) {
    return true;
  }
  for (let alt_key of control.alt || []) {
    if (key === get_key_from_display_key(alt_key)) {
      return true;
    }
  }
  return false;
}

export function match_key(key: string): Optional<Controls> {
  let matches: Array<Controls> = []
  Object.values(ALL_CONTROLS).forEach((control: Controls) => {
    if (check_key(control, key)) {
      matches.push(control);
    }
  })
  if (matches.length === 0) {
    return null;
  } else if (matches.length === 1) {
    return matches[0]
  } else {
    throw new Error(`Multiple controls registered for ${key}`)
  }
}

function register_controls(control: Controls) {
  ALL_CONTROLS[control.description] = control;
  return control;
}

export const control_menu: Controls = register_controls({
  main: 'esc',
  alt: ['p'],
  description: 'Controls menu'
})

export const credits_menu: Controls = register_controls({
  main: ':',
  alt: [],
  description: 'Credits menu'
})

export const about_menu: Controls = register_controls({
  main: '?',
  alt: [],
  description: 'About menu'
})

export const levels_menu: Controls = register_controls({
  main: 'l',
  alt: [],
  description: 'Levels menu'
})

export const up: Controls = register_controls({
  main: 'ArrowUp',
  alt: ['w'],
  description: 'Up'
})

export const down: Controls = register_controls({
  main: 'ArrowDown',
  alt: ['s'],
  description: 'Down'
})

export const left: Controls = register_controls({
  main: 'ArrowLeft',
  alt: ['a'],
  description: 'Left'
})

export const right: Controls = register_controls({
  main: 'ArrowRight',
  alt: ['d'],
  description: 'Right'
})

export const wait: Controls = register_controls({
  main: 'space',
  alt: ['t'],
  description: 'Tick time'
})

export const borrow: Controls = register_controls({
  main: 'x',
  alt: ['e'],
  description: 'Exit event'
})

export const cycle_player: Controls = register_controls({
  main: 'tab',
  alt: ['c', 'enter'],
  description: 'Change bird'
})


export const undo: Controls = register_controls({
  main: 'z',
  alt: ['u'],
  description: 'Undo action'
})

export const redo: Controls = register_controls({
  main: 'Z',
  alt: ['y'],
  description: 'Redo action'
})

export const reset: Controls = register_controls({
  main: 'r',
  alt: [],
  description: 'Reset level'
})


export const level_back: Controls = register_controls({
  main: 'b',
  alt: [],
  description: 'Previous level'
})

export const level_back_cheat: Controls = register_controls({
  main: 'B',
  alt: [],
  description: ''
})

export const level_next: Controls = register_controls({
  main: 'n',
  alt: [],
  description: 'Next level'
})

export const level_next_cheat: Controls = register_controls({
  main: 'N',
  alt: [],
  description: ''
})

